{
  "header": {
    "title": "Outage Management",
    "description": "Plan, monitor, and review generating unit outages across the registered portfolio."
  },
  "outages": [
    {
      "id": 1,
      "outageId": "OUT-2026-0001",
      "qcaCode": "QCA-001",
      "pssCode": "PSS-001",
      "generatingCompanyCode": "GEN-001",
      "generatingUnitCode": "UNIT-1001",
      "outageType": "Planned",
      "startDateTime": "2026-08-07T00:00",
      "endDateTime": "2026-08-08T23:59",
      "status": "Active",
      "reason": "Maintenance",
      "description": "Routine maintenance of inverter and panel cleaning.",
      "expectedImpactMw": 50,
      "documentName": "maintenance-plan-001.pdf"
    },
    {
      "id": 2,
      "outageId": "OUT-2026-0002",
      "qcaCode": "QCA-003",
      "pssCode": "PSS-003",
      "generatingCompanyCode": "GEN-003",
      "generatingUnitCode": "UNIT-2001",
      "outageType": "Planned",
      "startDateTime": "2026-08-09T00:00",
      "endDateTime": "2026-08-11T23:59",
      "status": "Scheduled",
      "reason": "Inspection",
      "description": "Scheduled inspection and preventive service.",
      "expectedImpactMw": 90,
      "documentName": "inspection-002.pdf"
    },
    {
      "id": 3,
      "outageId": "OUT-2026-0003",
      "qcaCode": "QCA-007",
      "pssCode": "PSS-007",
      "generatingCompanyCode": "GEN-007",
      "generatingUnitCode": "UNIT-6001",
      "outageType": "Forced",
      "startDateTime": "2026-08-07T10:30",
      "endDateTime": "2026-08-07T16:30",
      "status": "Completed",
      "reason": "Equipment fault",
      "description": "Unplanned inverter protection trip.",
      "expectedImpactMw": 52.5,
      "documentName": "fault-report-003.pdf"
    },
    {
      "id": 4,
      "outageId": "OUT-2026-0004",
      "qcaCode": "QCA-004",
      "pssCode": "PSS-004",
      "generatingCompanyCode": "GEN-004",
      "generatingUnitCode": "UNIT-3001",
      "outageType": "Planned",
      "startDateTime": "2026-08-10T00:00",
      "endDateTime": "2026-08-12T23:59",
      "status": "Scheduled",
      "reason": "Annual service",
      "description": "Annual service of plant auxiliaries.",
      "expectedImpactMw": 70,
      "documentName": "annual-service-004.pdf"
    },
    {
      "id": 5,
      "outageId": "OUT-2026-0005",
      "qcaCode": "QCA-005",
      "pssCode": "PSS-005",
      "generatingCompanyCode": "GEN-005",
      "generatingUnitCode": "UNIT-4001",
      "outageType": "Forced",
      "startDateTime": "2026-08-07T12:15",
      "endDateTime": "2026-08-07T14:45",
      "status": "Completed",
      "reason": "Grid disturbance",
      "description": "Temporary shutdown after a grid disturbance.",
      "expectedImpactMw": 80,
      "documentName": "grid-event-005.pdf"
    },
    {
      "id": 6,
      "outageId": "OUT-2026-0006",
      "qcaCode": "QCA-006",
      "pssCode": "PSS-006",
      "generatingCompanyCode": "GEN-006",
      "generatingUnitCode": "UNIT-5001",
      "outageType": "Planned",
      "startDateTime": "2026-08-15T00:00",
      "endDateTime": "2026-08-16T23:59",
      "status": "Scheduled",
      "reason": "Component replacement",
      "description": "Replacement of scheduled-life components.",
      "expectedImpactMw": 55,
      "documentName": "replacement-006.pdf"
    },
    {
      "id": 7,
      "outageId": "OUT-2026-0007",
      "qcaCode": "QCA-008",
      "pssCode": "PSS-008",
      "generatingCompanyCode": "GEN-008",
      "generatingUnitCode": "UNIT-7001",
      "outageType": "Planned",
      "startDateTime": "2026-08-20T00:00",
      "endDateTime": "2026-08-22T23:59",
      "status": "Scheduled",
      "reason": "Preventive maintenance",
      "description": "Preventive maintenance of generation equipment.",
      "expectedImpactMw": 65,
      "documentName": "preventive-007.pdf"
    },
    {
      "id": 8,
      "outageId": "OUT-2026-0008",
      "qcaCode": "QCA-009",
      "pssCode": "PSS-009",
      "generatingCompanyCode": "GEN-009",
      "generatingUnitCode": "UNIT-8001",
      "outageType": "Forced",
      "startDateTime": "2026-08-18T09:00",
      "endDateTime": "2026-08-18T11:00",
      "status": "Completed",
      "reason": "Protection alarm",
      "description": "Investigation and reset of protection alarm.",
      "expectedImpactMw": 80,
      "documentName": "protection-008.pdf"
    },
    {
      "id": 9,
      "outageId": "OUT-2026-0009",
      "qcaCode": "QCA-010",
      "pssCode": "PSS-010",
      "generatingCompanyCode": "GEN-010",
      "generatingUnitCode": "UNIT-9001",
      "outageType": "Planned",
      "startDateTime": "2026-08-25T00:00",
      "endDateTime": "2026-08-27T23:59",
      "status": "Scheduled",
      "reason": "Planned overhaul",
      "description": "Planned overhaul before the peak season.",
      "expectedImpactMw": 49,
      "documentName": "overhaul-009.pdf"
    },
    {
      "id": 10,
      "outageId": "OUT-2026-0010",
      "qcaCode": "QCA-001",
      "pssCode": "PSS-001",
      "generatingCompanyCode": "GEN-001",
      "generatingUnitCode": "UNIT-1002",
      "outageType": "Forced",
      "startDateTime": "2026-08-07T09:00",
      "endDateTime": "2026-08-07T11:00",
      "status": "Completed",
      "reason": "Inverter trip",
      "description": "Short duration inverter trip and restart.",
      "expectedImpactMw": 50,
      "documentName": "trip-010.pdf"
    },
    {
      "id": 11,
      "outageId": "OUT-2026-0011",
      "qcaCode": "QCA-05",
      "qcaName": "MH_KREATE",
      "pssCode": "PSS-004",
      "pssName": "Kolhapur PSS 4",
      "generatingCompanyCode": "GEN-005",
      "generatingCompanyName": "Green Hybrid Plant Pvt. Ltd.",
      "generatingUnitCode": "GH-Unit-02",
      "generatingUnitName": "GH-Unit-02",
      "outageType": "Planned",
      "startDateTime": "2026-08-12T00:00",
      "endDateTime": "2026-08-13T23:59",
      "duration": "2 Days",
      "status": "Scheduled",
      "reason": "Battery Maintenance",
      "expectedImpactMw": 100
    },
    {
      "id": 12,
      "outageId": "OUT-2026-0012",
      "qcaCode": "QCA-07",
      "qcaName": "MH_CLEAN",
      "pssCode": "PSS-012",
      "pssName": "PSS-012",
      "generatingCompanyCode": "GEN-008",
      "generatingCompanyName": "Adani Green Energy Ltd.",
      "generatingUnitCode": "AG-Unit-01",
      "generatingUnitName": "AG-Unit-01",
      "outageType": "Forced",
      "startDateTime": "2026-08-08T03:15",
      "endDateTime": "2026-08-08T08:15",
      "duration": "5 Hrs",
      "status": "Active",
      "reason": "Transformer Fault",
      "expectedImpactMw": 50
    },
    {
      "id": 13,
      "outageId": "OUT-2026-0013",
      "qcaCode": "QCA-08",
      "qcaName": "MH_WALWHAN",
      "pssCode": "PSS-015",
      "pssName": "PSS-015",
      "generatingCompanyCode": "GEN-009",
      "generatingCompanyName": "Ace Solar Power Pvt. Ltd.",
      "generatingUnitCode": "AS-Unit-01",
      "generatingUnitName": "AS-Unit-01",
      "outageType": "Planned",
      "startDateTime": "2026-08-18T00:00",
      "endDateTime": "2026-08-18T23:59",
      "duration": "1 Day",
      "status": "Scheduled",
      "reason": "Inverter Maintenance",
      "expectedImpactMw": 25
    },
    {
      "id": 14,
      "outageId": "OUT-2026-0014",
      "qcaCode": "QCA-09",
      "qcaName": "MH_MSEDCL",
      "pssCode": "PSS-018",
      "pssName": "PSS-018",
      "generatingCompanyCode": "GEN-010",
      "generatingCompanyName": "SolarGen Maharashtra Ltd.",
      "generatingUnitCode": "SG-Unit-01",
      "generatingUnitName": "SG-Unit-01",
      "outageType": "Planned",
      "startDateTime": "2026-08-14T00:00",
      "endDateTime": "2026-08-15T23:59",
      "duration": "2 Days",
      "status": "Scheduled",
      "reason": "Module Cleaning",
      "expectedImpactMw": 100
    },
    {
      "id": 15,
      "outageId": "OUT-2026-0015",
      "qcaCode": "QCA-10",
      "qcaName": "MH_SHARDA",
      "pssCode": "PSS-020",
      "pssName": "PSS-020",
      "generatingCompanyCode": "GEN-004",
      "generatingCompanyName": "Maharashtra Solar One",
      "generatingUnitCode": "MS-Unit-01",
      "generatingUnitName": "MS-Unit-01",
      "outageType": "Forced",
      "startDateTime": "2026-08-08T14:00",
      "endDateTime": "2026-08-08T18:30",
      "duration": "4 Hrs 30 Mins",
      "status": "Active",
      "reason": "SCADA Communication Failure",
      "expectedImpactMw": 50
    },
    {
      "id": 16,
      "outageId": "OUT-2026-0016",
      "qcaCode": "QCA-11",
      "qcaName": "Solar Energy QCA 11",
      "pssCode": "PSS-022",
      "pssName": "PSS-022",
      "generatingCompanyCode": "GEN-005",
      "generatingCompanyName": "Pune Wind Energy Ltd.",
      "generatingUnitCode": "PW-Unit-01",
      "generatingUnitName": "PW-Unit-01",
      "outageType": "Planned",
      "startDateTime": "2026-08-21T00:00",
      "endDateTime": "2026-08-23T23:59",
      "duration": "3 Days",
      "status": "Scheduled",
      "reason": "Turbine Maintenance",
      "expectedImpactMw": 80
    },
    {
      "id": 17,
      "outageId": "OUT-2026-0017",
      "qcaCode": "QCA-12",
      "qcaName": "Hybrid Energy QCA 12",
      "pssCode": "PSS-025",
      "pssName": "PSS-025",
      "generatingCompanyCode": "GEN-006",
      "generatingCompanyName": "Nashik Renewable Energy",
      "generatingUnitCode": "NR-Unit-01",
      "generatingUnitName": "NR-Unit-01",
      "outageType": "Planned",
      "startDateTime": "2026-08-16T00:00",
      "endDateTime": "2026-08-17T23:59",
      "duration": "2 Days",
      "status": "Scheduled",
      "reason": "Preventive Maintenance",
      "expectedImpactMw": 40
    },
    {
      "id": 18,
      "outageId": "OUT-2026-0018",
      "qcaCode": "QCA-13",
      "qcaName": "Solar Energy QCA 13",
      "pssCode": "PSS-028",
      "pssName": "PSS-028",
      "generatingCompanyCode": "GEN-007",
      "generatingCompanyName": "Satara Solar Power Ltd.",
      "generatingUnitCode": "SS-Unit-01",
      "generatingUnitName": "SS-Unit-01",
      "outageType": "Forced",
      "startDateTime": "2026-08-08T06:30",
      "endDateTime": "2026-08-08T09:00",
      "duration": "2 Hrs 30 Mins",
      "status": "Completed",
      "reason": "Inverter Trip",
      "expectedImpactMw": 60
    },
    {
      "id": 19,
      "outageId": "OUT-2026-0019",
      "qcaCode": "QCA-14",
      "qcaName": "Hybrid Energy QCA 14",
      "pssCode": "PSS-031",
      "pssName": "PSS-031",
      "generatingCompanyCode": "GEN-008",
      "generatingCompanyName": "Kolhapur Green Energy",
      "generatingUnitCode": "KG-Unit-01",
      "generatingUnitName": "KG-Unit-01",
      "outageType": "Planned",
      "startDateTime": "2026-08-26T00:00",
      "endDateTime": "2026-08-28T23:59",
      "duration": "3 Days",
      "status": "Scheduled",
      "reason": "Transformer Maintenance",
      "expectedImpactMw": 90
    },
    {
      "id": 20,
      "outageId": "OUT-2026-0020",
      "qcaCode": "QCA-15",
      "qcaName": "Solar Energy QCA 15",
      "pssCode": "PSS-035",
      "pssName": "PSS-035",
      "generatingCompanyCode": "GEN-009",
      "generatingCompanyName": "Solapur Solar Plant",
      "generatingUnitCode": "SL-Unit-01",
      "generatingUnitName": "SL-Unit-01",
      "outageType": "Planned",
      "startDateTime": "2026-08-19T00:00",
      "endDateTime": "2026-08-20T23:59",
      "duration": "2 Days",
      "status": "Scheduled",
      "reason": "Panel Replacement",
      "expectedImpactMw": 120
    },
    {
      "id": 21,
      "outageId": "OUT-2026-0021",
      "qcaCode": "QCA-16",
      "qcaName": "Hybrid Energy QCA 16",
      "pssCode": "PSS-039",
      "pssName": "PSS-039",
      "generatingCompanyCode": "GEN-010",
      "generatingCompanyName": "Amravati Wind Farm",
      "generatingUnitCode": "AW-Unit-01",
      "generatingUnitName": "AW-Unit-01",
      "outageType": "Forced",
      "startDateTime": "2026-08-08T11:15",
      "endDateTime": "2026-08-08T15:15",
      "duration": "4 Hrs",
      "status": "Active",
      "reason": "Bearing Failure",
      "expectedImpactMw": 75
    },
    {
      "id": 22,
      "outageId": "OUT-2026-0022",
      "qcaCode": "QCA-17",
      "qcaName": "Solar Energy QCA 17",
      "pssCode": "PSS-042",
      "pssName": "PSS-042",
      "generatingCompanyCode": "GEN-006",
      "generatingCompanyName": "Nagpur Solar Energy",
      "generatingUnitCode": "NS-Unit-01",
      "generatingUnitName": "NS-Unit-01",
      "outageType": "Planned",
      "startDateTime": "2026-08-29T00:00",
      "endDateTime": "2026-08-30T23:59",
      "duration": "2 Days",
      "status": "Scheduled",
      "reason": "Annual Inspection",
      "expectedImpactMw": 100
    },
    {
      "id": 23,
      "outageId": "OUT-2026-0023",
      "qcaCode": "QCA-18",
      "qcaName": "Solar Energy QCA 18",
      "pssCode": "PSS-047",
      "pssName": "PSS-047",
      "generatingCompanyCode": "GEN-007",
      "generatingCompanyName": "Latur Renewable Energy",
      "generatingUnitCode": "LR-Unit-01",
      "generatingUnitName": "LR-Unit-01",
      "outageType": "Forced",
      "startDateTime": "2026-08-08T08:00",
      "endDateTime": "2026-08-08T10:30",
      "duration": "2 Hrs 30 Mins",
      "status": "Completed",
      "reason": "Grid Disturbance",
      "expectedImpactMw": 50
    }
  ]
}
